import { useContext } from 'react';
import { aiAssistantContext } from '../../../state/AIAssistantContextProvider';
import { aiAssistantEditorContext } from '../../../state/AIAssistantEditorProvider';
import { setCurrentConversationId } from '../../../actions/aiAssistant.actions';
import useAction from '../../../utils/useAction';
import useRouter from '../../../utils/useRouter';
import { routes } from '../../../constants';
import { ActiveView } from './constants';

// Back-to-KI-Tools-start sequence, shared by the breadcrumb and the mobile podcast header.
const useBackToAIToolsMain = () => {
  const { setActiveView, setSelectedTemplatePromptId } = useContext(aiAssistantContext);
  const { closeTextEditor } = useContext(aiAssistantEditorContext);
  const setCurrentConversationIdAction = useAction(setCurrentConversationId);
  const { router } = useRouter();

  return () => {
    // Close the editor first: its page-scoped state survives in-page navigation otherwise.
    closeTextEditor();
    setActiveView(ActiveView.FREE_DRAFT_ENTRY);
    setSelectedTemplatePromptId(null);
    setCurrentConversationIdAction({ conversationId: null });
    router.replace(`/${routes.aiTools.root}`);
  };
};

export default useBackToAIToolsMain;
